export default "__VITE_ASSET__8371e69d__"